import { baseUrl, headers } from 'api';
import { WhiteButton, BlueButton } from 'components/atoms';
import { Modal } from 'components/molecules';
import { toast } from 'react-toastify';

import * as S from './styles';

export const ModalContratar = ({ aluno, isOpen, onClose }) => {
  const handleContratar = () => {
    fetch(`${baseUrl}/processo-aluno/${aluno.id}/contratar/`, {
      method: 'POST',
      headers: {
        ...headers,
        authorization: sessionStorage.getItem('@senac:token'),
      },
    }).then((response) => {
      if (response.ok) {
        toast.success('Aluno contratado com sucesso!');
        onClose();
      } else {
        toast.error('Erro ao contratar aluno!');
      }
    });
  };

  return (
    <Modal title="Contratar currículo" isOpen={isOpen} onClose={onClose}>
      <S.ModalContent>
        <p>Você tem certeza que deseja contratar este currículo?</p>
        <div className="buttons">
          <WhiteButton onClick={onClose}>Cancelar</WhiteButton>
          <BlueButton onClick={() => handleContratar()}>Confirmar</BlueButton>
        </div>
      </S.ModalContent>
    </Modal>
  );
};
